
















































































































































































































import { auth } from "firebase/app";
import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import { Wormhole } from "portal-vue";
import { mustChangePlaceholderCredentials } from "@/utils/ClientCredentialsUtils";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import { UserModule } from "@/store/modules/UserModule";
import {
  getActiveUser,
  getReactiveActiveUser,
  observeUsers,
  storeSessionEnded,
  clearPortalSessionToken,
  persistActiveUserDarkMode,
} from "@/data/repository/UserRepository";
import {
  doesClientHaveApp,
  getProjectManagement,
  isExternalSystem,
  isIresClient,
  observeClient,
  getProjectManagementType,
  updateIgnoreIresAdminOrIresClientCheck,
  observeBranchesOfGroup,
  getClientInfo,
} from "@/data/repository/ClientRepository";
import { observeRoleSettings } from "@/data/repository/RoleSettingsRepository";
import Client, { ProjectManagement, SystemConfiguration } from "@/data/models/Client";
import User from "@/data/models/User";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import SetNewPasswordComponent from "@/components/users/SetNewPassword.vue";
import SelectLicencesComponent from "@/components/users/SelectLicences.vue";
import ChangeEmailAndPasswordComponent from "@/components/settings/ChangeClientEmailAndPassword.vue";
import StaleCloseConfirmationDialogComponent, { StaleCloseDialogResult } from "@/components/timeTracking/StaleCloseConfirmationDialog.vue";
import { RoleSettings } from "@/data/models/RoleSettings";
import { RoleSettingsModule } from "@/store/modules/RoleSettingsModule";
import { UserSettingsModule } from "@/store/modules/UserSettingsModule";
import { ReportSettingsModule } from "@/store/modules/ReportSettingsModule";
import { CompanySettingsModule } from "@/store/modules/CompanySettingsModule";
import { HyDryDeviceSettingsModule } from "@/store/modules/HyDryDeviceSettingsModule";
import { SystemConfigurationModule } from "@/store/modules/SystemConfigurationModule";
import { FinishedProjectsSettingsModule } from "@/store/modules/FinishedProjectsSettingsModule";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { getSharedEmailAddressInfo } from "@/data/repository/SharedEmailAddressRepository";
import { observeSystemConfiguration } from "@/data/repository/SystemConfigurationRepository";
import { manageAllDevicesClientAccess, manageMessagesClientAccess, manageProjectsClientAccess, manageTimeTrackingClientAccess, isOfficeAdminPortalClient } from "@/permissions/ClientPermissions";
import { getCockpitPath } from "@/utils/CockpitPath";
import { hasAccess, hasPathAccess } from "@/utils/RouteGuards";
import { previewOpenTimeTrackingAutoClose, applyOpenTimeTrackingAutoClose } from "@/data/repository/TimeTrackingRepository";
import { PreviewOpenTimeTrackingAutoCloseResponse } from "@/data/models/TimeTracking";
import { DEFAULT_TIMEZONE } from "@/utils/TimezoneHelper";
import { ProjectOperationSource } from "@/data/models/ProjectDetails";
import { 
  alwaysAllowedToViewTimeTrackingAccess,
  darkModeAccess,
  mapPageAccess, 
  miraAccess,
  iresSettingsAccess,
  rateDryingsAccess,
  replaceTemporaryPasswordAccess,
  schedulingSettingsAccess,
  vehicleManagementAccess, 
} from "@/permissions/UserPermissions";
import { isClientSignInBlocked, rememberSignInRefusal } from "@/utils/SignInRefusal";
import { 
  AllDevicesSettings, 
  CompanySettings, 
  FinishedProjectsSettings, 
  getProjectSettingsV2,
  HyDryDeviceSettings, 
  ProjectManagementSettings, 
  ReportSettings, 
  UserSettings 
} from "@/data/models/Settings";
import { 
  observeCompanySettings, 
  observeReportSettings, 
  observeUserSettings, 
  observeHyDryDeviceSettings, 
  observeProjectManagementSettings, 
  observeAllDevicesSettings,
  observeLocalDeviceCategoriesAndTemplates,
  observeSharedDeviceCategoriesAndTemplates,
  observeHyDryMessagesSettings,
  observeFinishedProjectsSettings
} from "@/data/repository/SettingsRepository";
import { changeLanguageTo } from "@/i18n/Languages";
import { changeThemeTo, themed } from "@/utils/Theme";
import { COLOR_APP_BAR_DARK } from "@/utils/colors";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { AllDevicesSettingsModule } from "@/store/modules/AllDevicesSettingsModule";
import { DeviceCategoriesAndTemplates } from "@/data/models/DeviceSettingsManager";
import { HyDryMessagesSettings } from "@/data/models/HyDryMessagesConfig";
import { HyDryMessagesSettingsModule } from "@/store/modules/HyDryMessagesSettingsModule";
import { ClientModule } from "@/store/modules/ClientModule";
import { MemberClientBranch } from "@/data/models/Branch";
import { BranchesModule } from "@/store/modules/BranchesModule";
import {
  COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND,
  COLOR_VIEW_AS_USER_HIGHLIGHT,
  COLOR_VIEW_AS_USER_HIGHLIGHT_DARK,
} from "@/utils/colors";
import { canAccessTimeTrackingHistory } from "@/utils/timeTrackingHistoryAccess";
import CompanyHeaderComponent from "@/components/common/CompanyHeader.vue";
import {
  endViewAs,
  getEffectiveUser,
  getViewAsResolution,
  getViewAsUser,
  isViewAsSelected,
  restoreViewAs,
} from "@/utils/ViewAs";
import { ViewAsEndReason } from "@/utils/TargetUserSelection";
import {
  hasRenderableToolbarContent,
  shouldRenderToolbarContextFallback,
  getToolbarContextClientName,
  getToolbarContextUserText,
  TOOLBAR_OVERFLOW_PORTAL,
} from "@/utils/ToolbarContext";
import { resolveOfficeAdminPortalClient } from "@/data/repository/AdministrationRepository";
import AppUpdateBannerComponent from "@/components/common/AppUpdateBanner.vue";
import ViewAsChipComponent from "@/components/common/ViewAsChip.vue";
import { AppUpdateModule } from "@/store/modules/AppUpdateModule";
import { AppUpdateChecker } from "@/utils/AppUpdateChecker";
import { getActiveNavAction } from "@/utils/NavigationHighlight";

@Component({
  components: {
    'confirmation-dialog': ConfirmationDialogComponent,
    'set-new-password': SetNewPasswordComponent,
    'select-licences': SelectLicencesComponent,
    'change-email-and-password': ChangeEmailAndPasswordComponent,
    'company-header': CompanyHeaderComponent,
    'stale-close-confirmation-dialog': StaleCloseConfirmationDialogComponent,
    'app-update-banner': AppUpdateBannerComponent,
    'view-as-chip': ViewAsChipComponent,
  }
})
export default class Scaffold extends Vue {
  drawer: boolean | null = null;

  pressTimer: number | undefined = undefined;
  longPressTriggered = false;
  
  projectManagementType = getProjectManagementType();

  // Global snackbar computed properties
  get snackbarVisible() { return SnackbarModule.visible; }
  get snackbarColor() { return SnackbarModule.snackbarColor; }
  get snackbarTimeout() { return SnackbarModule.timeout; }
  get snackbarI18nKey() { return SnackbarModule.i18nKey; }
  get snackbarI18nParams() { return SnackbarModule.i18nParams; }

  onSnackbarInput(value: boolean) {
    if (!value) {
      SnackbarModule.hide();
    }
  }

  /**
   * Polls the deployed build while the authenticated shell is alive.
   *
   * Declared without an initializer on purpose, so it stays a plain instance property instead of
   * becoming reactive data — nothing renders from the checker itself, only from AppUpdateModule.
   */
  private appUpdateChecker!: AppUpdateChecker | null;

  /** Whether the "new version" banner should be on screen (see AppUpdateModule). */
  get isUpdateOffered() { return AppUpdateModule.isUpdateOffered; }

  get isApplyingUpdate() { return AppUpdateModule.isApplyingUpdate; }

  private startAppUpdateChecker() {
    this.appUpdateChecker = new AppUpdateChecker((deployed) => {
      AppUpdateModule.setPendingBuild(deployed);
    });

    this.appUpdateChecker.start();
  }

  /** REFRESH: reload onto the deployed build. The busy state stays until the document goes away. */
  onApplyUpdate() {
    if (!this.appUpdateChecker) {
      // Nothing to reload through, so do not leave the button spinning forever.
      return;
    }

    AppUpdateModule.setApplyingUpdate(true);
    this.appUpdateChecker.applyUpdate();
  }

  /**
   * LATER: hide the offer for this build only. A build deployed after this one resurfaces the
   * banner, so a single dismissal cannot silence the rest of the session.
   */
  onDismissUpdate() {
    AppUpdateModule.dismissPendingUpdate();
  }

  @Ref("confirmSignOut")
  confirmationDialog!: ConfirmationDialogComponent;

  @Ref("setNewPassword")
  setNewPassword!: SetNewPasswordComponent;

  @Ref("selectedLicences")
  selectedLicences!: SelectLicencesComponent;

  @Ref("changeEmailAndPassword")
  changeEmailAndPassword!: ChangeEmailAndPasswordComponent;

  @Ref("staleCloseDialog")
  staleCloseDialog!: StaleCloseConfirmationDialogComponent;

  /** Prevents concurrent stale-close checks (e.g. while the confirmation dialog is open). */
  private staleCheckInFlight = false;
  /** Client-timezone day of the last stale-close check; lets it re-run after midnight. */
  private lastStaleCheckDay: string | null = null;

  subscriptions: Array<() => void> = [];
  projectManagement = getProjectManagement();

  showBackArrow = false;
  scaffoldItems: { title: string; icon: string; action: string }[] = [];

  /**
   * Whether a drawer entry is highlighted: only the most specific entry matching the route (see
   * `getActiveNavAction`), so a nested entry such as RENO Schnellprüfung does not also light its
   * parent, IRES Admin. The entries are `exact` links, so Vue Router's own inclusive highlight
   * no longer adds a second one.
   */
  isNavItemActive(item: { action: string }): boolean {
    return getActiveNavAction(this.$route.path, this.scaffoldItems.map((navItem) => navItem.action)) === item.action;
  }
  /**
   * Whether this client may enter the admin portal. Resolved asynchronously because it reads
   * Firestore, so it starts false and the nav entry appears once the check completes. The router
   * guard is the real gate; this only controls visibility.
   */
  isOfficeAdmin = false;
  hasToolbarContentActions = false;
  hasToolbarMenuActions = false;
  toolbarActionsObserver: MutationObserver | null = null;
  clientInfo = getClientInfo();
  overflowPortal = TOOLBAR_OVERFLOW_PORTAL;
  toolbarActionsResolutionTimer: number | null = null;

  updateScaffoldContent() {
    this.scaffoldItems = this.items();
  }

  /** Resolves admin-portal visibility, then rebuilds the nav so the entry can appear. */
  private async resolveOfficeAdminAccess() {
    this.isOfficeAdmin = await resolveOfficeAdminPortalClient();
    this.updateScaffoldContent();
  }

  /**
   * Whether to hide the project-oriented navigation.
   *
   * The IRES admin portal is a device- and administration-only tenant: verified against production
   * it holds no projects, no project states and no reports, so entries like Projekte, Planung,
   * Fahrzeuge, Zeiterfassung and Karten lead to empty screens. HyDry Geräte and Nachrichten are
   * hidden as well (Taimoor, 2026-09-30), and the router blocks their pages by URL.
   *
   * Reads the cached synchronous predicate rather than this component's `isOfficeAdmin`, so the
   * answer is already correct on the first render after a reload instead of flipping once the
   * async lookup returns. Settings hides its own sections from the same predicate.
   */
  get hidesProjectFeatures() {
    return isOfficeAdminPortalClient();
  }

  get ignoreIresAdminOrIresClientCheck() {
    return ClientModule.ignoreIresAdminOrIresClientCheck;
  }

  get isAllowedToSwitchIresCapabilities() {
    const activeUser = this.activeUser;

    return iresSettingsAccess(activeUser);
  }

  get canAlwaysViewTimeTracking() {
    return alwaysAllowedToViewTimeTrackingAccess(this.activeUser);
  }

  get isBelforWebsite() {
    return window.location.href.toLowerCase().includes("belfor");
  }

  get isSvtWebsite() {
    return window.location.href.toLowerCase().includes("svt");
  }

  get includeKeepAlive() {
    return [
      "ArchivedProjectsComponent",
      "ProjectsComponent",
      "SchedulingComponent",
      "CockpitComponent",
      "IresDeviceListComponent",
      "DryingHistoryComponent",
      "MessageListComponent",
      "ClientAdministrationListComponent",
      // The Externe Systeme list (#2610084): back from a system's page shows it at once.
      "ExternalSystemList",
      "ClientAdministrationDetailComponent",
      "ClientAdministrationProjectsComponent",
      // The rest of the IRES Admin Client a page returns to: back shows it at once, no reload.
      "AdminCockpitComponent",
      "ClientAdministrationDevicesComponent",
      "ClientAdministrationPdfTemplatesComponent",
      "InfoConfigVersionListComponent",
      "DeviceReportResultsComponent",
    ].join(",");
  }

  get title() {
    const { rawTitle, i18nResource } = ToolbarContentModule.toolbarTitleValues;

    if (i18nResource) {
      return this.$t(i18nResource);
    }

    if (rawTitle) {
      return rawTitle;
    }

    return "";
  }

  get style() {
    if (!this.isAllowedToSwitchIresCapabilities) {
      return "";
    }

    return this.ignoreIresAdminOrIresClientCheck
      ? ""
      : `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`;
  }

  /** Whether the app is currently rendered in dark mode (reactive Vuetify state). */
  get isDarkTheme() {
    return this.$vuetify.theme.dark;
  }

  /**
   * Whether this user may switch appearance. IRES-only until dark mode is released to clients.
   *
   * Uses the reactive active user so the drawer entry appears/disappears in-session if the
   * capability changes, rather than going stale until a page refresh.
   */
  get canUseDarkMode() {
    return darkModeAccess(this.activeUser);
  }

  /**
   * Forces the light theme for anyone without {@link canUseDarkMode}.
   *
   * Hiding the toggle is not sufficient: `ThemeVuexModule.resolveInitialDark()` falls back to the
   * OS `prefers-color-scheme` when no preference is stored, so a client user on a dark-themed OS
   * would start in dark mode with no way to leave it. Also covers a stale stored preference or a
   * `darkMode` flag left on the user document from testing.
   */
  private enforceDarkModeAccess() {
    if (!this.canUseDarkMode && this.$vuetify.theme.dark) {
      changeThemeTo(false);
    }
  }

  /** Re-checks as soon as the active user resolves, since the capability depends on it. */
  @Watch("activeUser")
  onActiveUserChangedForTheme() {
    this.enforceDarkModeAccess();
  }

  /** App-bar color: brand `primary` in light mode, a muted dark blue in dark mode. */
  get appBarColor() {
    return themed("primary", COLOR_APP_BAR_DARK);
  }

  /**
   * Toggles between light and dark appearance. The choice is cached per-browser
   * (localStorage) by changeThemeTo and, for a signed-in user, also persisted to
   * their user document so it follows them across devices.
   */
  toggleTheme() {
    if (!this.canUseDarkMode) {
      return;
    }

    const isDark = !this.$vuetify.theme.dark;
    changeThemeTo(isDark);
    void persistActiveUserDarkMode(isDark);
  }

  get activeUser() {
    return getReactiveActiveUser();
  }

  /** The user "Sicht auf" shows, or `null` for the own view. */
  get viewAsUser() {
    return getViewAsUser();
  }

  /**
   * Whose menu this is: the chosen user's while "Sicht auf" is active (ticket 2610052). `activeUser`
   * stays the signed-in person, for "Angemeldet als", the session, licences and the theme.
   */
  get effectiveUser() {
    return getEffectiveUser();
  }

  /** The phones' eye: the chip itself lives in the drawer there. */
  get viewAsEyeLabel() {
    const viewAsUser = this.viewAsUser;

    return viewAsUser ? this.$t("common.viewOf", [viewAsUser.nickname]).toString() : "";
  }

  get viewAsEyeColor() {
    return themed(COLOR_VIEW_AS_USER_HIGHLIGHT, COLOR_VIEW_AS_USER_HIGHLIGHT_DARK);
  }

  /** Whether a screen has put a header context (the Cockpit's) into the bar's centre. */
  get hasToolbarCenterContent() {
    return Wormhole.hasContentFor("toolbar-center");
  }

  /**
   * Re-creates the page when "Sicht auf" starts, ends or changes user, so every screen reads the
   * choice afresh (ticket 2610050). It also covers a refresh: the choice resolves only once the user
   * list has loaded, and the page then shows the chosen user.
   */
  get routerViewKey() {
    const viewAsUser = this.viewAsUser;

    return viewAsUser ? `${this.$route.fullPath}#viewAs=${viewAsUser.id}` : this.$route.fullPath;
  }

  /** A "Sicht auf" choice is stored, resolved or not: read-only applies from here (ticket 2610051). */
  get isViewAsSelected() {
    return isViewAsSelected();
  }

  /**
   * The chosen user resolved, changed or went: rebuild the menu for them and, if the page open now is
   * not one they could open, leave it, as the route guard would have (ticket 2610052). The guard ran
   * before "Sicht auf" was restored after a refresh, or before it was started on this page.
   */
  @Watch("viewAsUserId")
  onViewAsUserChanged() {
    this.scaffoldItems = this.items();

    const route = this.$route;
    const projectSettings = getProjectSettingsV2(ProjectManagementSettingsModule.projectManagementSettings);
    const isOpen = hasAccess(route.name ?? undefined) && hasPathAccess(route.path, projectSettings);

    if (!isOpen) {
      SnackbarModule.showError({ key: "common.pageNotAvailable" });
      this.$router.replace(getCockpitPath(isOfficeAdminPortalClient()));
    }
  }

  /** The id only: the users snapshot replaces the user object on every change to any user. */
  get viewAsUserId() {
    return this.viewAsUser?.id ?? null;
  }

  /** The stale time-entry check paused while "Sicht auf" was active; run it now that it ended. */
  @Watch("isViewAsSelected")
  onViewAsSelectedChanged(isSelected: boolean) {
    // The menu is built per route, not reactively; the admin entries depend on "Sicht auf".
    this.scaffoldItems = this.items();

    if (!isSelected) {
      this.checkAndHandleStaleOpenEntry();
    }
  }

  get viewAsEndReason() {
    return getViewAsResolution().endReason;
  }

  /** The chosen user was deleted or blocked, or the viewer lost the right: end it and say why. */
  @Watch("viewAsEndReason", { immediate: true })
  onViewAsEndReasonChanged(reason: ViewAsEndReason | null) {
    if (!reason) {
      return;
    }

    endViewAs();
    SnackbarModule.showError({
      key: reason === ViewAsEndReason.NO_RIGHT
        ? "common.viewAsEndedNoRight"
        : "common.viewAsEndedUserUnavailable",
    });
  }

  /** Phone layout (below 600 px): icon actions beside the title, text actions in the ⋮ menu. */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /**
   * Phones and iPad mini (below 960 px): the client / user context heads the drawer instead of the
   * bar, and the title keeps to two lines; beside a long title it wrapped into a stack on an iPad mini.
   */
  get isCompactAppBar() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  /** Whether any screen has put a text action into the phone ⋮ menu (ToolbarOverflowItem). */
  get hasOverflowActions() {
    return Wormhole.hasContentFor(TOOLBAR_OVERFLOW_PORTAL);
  }

  get drawerClientName() {
    return getToolbarContextClientName(this.clientInfo);
  }

  get drawerUserContextText() {
    return getToolbarContextUserText(
      this.activeUser,
      (key: string, params: string[]) => this.$t(key, params).toString(),
    );
  }

  get showToolbarContextFallback() {
    const { toolbarActionsResolved, showClientUserContextFallback } =
      ToolbarContentModule.toolbarFallbackValues;

    return shouldRenderToolbarContextFallback(
      toolbarActionsResolved,
      this.hasToolbarContentActions,
      this.hasToolbarMenuActions,
      showClientUserContextFallback,
    );
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    const currentPath = this.$router.currentRoute.path;

    let showBackArrow = true;

    this.scaffoldItems = this.items();
    this.scaffoldItems.forEach((item) => {
      if (currentPath.endsWith(item.action) && showBackArrow) {
        showBackArrow = false;
      }
    });

    this.showBackArrow = showBackArrow;

    ToolbarContentModule.resetToolbarActionsState();

    this.$nextTick(() => {
      this.updateToolbarActionsPresence();
    });
  }

  scheduleToolbarActionsResolution() {
    if (this.toolbarActionsResolutionTimer != null) {
      clearTimeout(this.toolbarActionsResolutionTimer);
    }

    this.toolbarActionsResolutionTimer = window.setTimeout(() => {
      if (!this.hasToolbarContentActions && !this.hasToolbarMenuActions) {
        ToolbarContentModule.setToolbarActionsResolved(true);
      }

      this.toolbarActionsResolutionTimer = null;
    }, 700);
  }

  updateToolbarActionsPresence() {
    const contentPortal = this.$refs.toolbarContentPortal as Vue | undefined;
    const menuPortal = this.$refs.toolbarMenuPortal as Vue | undefined;

    this.hasToolbarContentActions = hasRenderableToolbarContent(contentPortal?.$el as HTMLElement | null);
    this.hasToolbarMenuActions = hasRenderableToolbarContent(menuPortal?.$el as HTMLElement | null);

    if (this.hasToolbarContentActions || this.hasToolbarMenuActions) {
      ToolbarContentModule.setToolbarActionsResolved(true);
      return;
    }

    this.scheduleToolbarActionsResolution();
  }

  observeToolbarActions() {
    const contentWrapper = this.$refs.toolbarContentPortalWrapper as HTMLElement | undefined;
    const menuWrapper = this.$refs.toolbarMenuPortalWrapper as HTMLElement | undefined;

    if (!contentWrapper || !menuWrapper) {
      return;
    }

    this.toolbarActionsObserver = new MutationObserver(() => {
      this.updateToolbarActionsPresence();
    });

    this.toolbarActionsObserver.observe(contentWrapper, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.toolbarActionsObserver.observe(menuWrapper, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.updateToolbarActionsPresence();
  }

  onNavIconClicked() {
    // Prevent execution of onNavIconClicked if long press was detected
    if (this.longPressTriggered) {
      this.longPressTriggered = false;  // Reset the flag after long press
      return;  // Skip normal click event
    }

    if (this.showBackArrow) {
      this.$router.back();
    } else {
      this.drawer = !this.drawer;
    }
  }

  onNavIconLongPressed() {
    if (!this.isAllowedToSwitchIresCapabilities) {
      return;
    }

    this.longPressTriggered = true;
    updateIgnoreIresAdminOrIresClientCheck(!this.ignoreIresAdminOrIresClientCheck);
  }

  isTouchEvent = false;

  // Start long click detection
  startPress(event: Event): void {
    event.preventDefault();
    this.isTouchEvent = event.type === "touchstart";

    // Set a timer for 1 second (1000 ms)
    this.pressTimer = window.setTimeout(() => {
      this.isTouchEvent = false;
      this.onNavIconLongPressed(); // Trigger long press action
    }, 1000);
  }

  // Cancel long click if user releases before 1 second
  cancelPress(): void {
    if (this.pressTimer) {
      clearTimeout(this.pressTimer);
      this.pressTimer = undefined;

      if (this.isTouchEvent) {
        this.isTouchEvent = false;
        this.onNavIconClicked(); // Trigger normal click action
      }
    }
  }

  async created() {
    // Before the page under Scaffold is created: it reads the choice once (ticket 2610050).
    restoreViewAs();
    this.scaffoldItems = this.items();
    this.$root.$refs.SCAFFOLDREF = this;
    this.enforceDarkModeAccess();

    // Deliberately not awaited: the nav must render immediately, and the admin entry appears
    // once the Firestore check resolves.
    this.resolveOfficeAdminAccess();
    
    this.subscriptions.push(
      observeUsers(async (before: User, after: User) => {
        // #2610124: on the IRES Admin Client a blocked user is signed out, IRES user or not, as its
        // users hold rights over every client.
        if (after.blocked && isOfficeAdminPortalClient()) {
          await this.signOutBlockedUser();
          return;
        }

        // IRES users skip the session and licence checks, but not the temporary password: every user
        // of an IRES-typed client holds this capability, the IRES Admin Client's included.
        const isIresUser = iresSettingsAccess(after);

        if (
          !isIresUser &&
          (before.licenceInfo?.portalSessionToken != after.licenceInfo?.portalSessionToken ||
            after.blocked)
        ) {
          if (!isIresClient(true)) {
            // #2610066: a blocked user is told so, not that they signed in elsewhere.
            if (after.blocked) {
              rememberSignInRefusal("USER_BLOCKED");
            } else {
              storeSessionEnded();
            }
            await this.signOut();
          }
        } else if (
          after.hasTemporaryPassword &&
          replaceTemporaryPasswordAccess(after) &&
          //Belfor/Svt does not have to set password since they use azure sso to authenticate
          !this.isBelforWebsite &&
          !this.isSvtWebsite
        ) {
          if (after.sharedEmailAddressId) {
            const sharedEmailAddressInfo = await getSharedEmailAddressInfo(after.sharedEmailAddressId);

            if (sharedEmailAddressInfo) {
              if (
                sharedEmailAddressInfo.emailSharingPasswordHashHex && 
                sharedEmailAddressInfo.emailSharingSalt
              ) {
                await this.setNewPassword.show(after, true, true);
              }
            }
          }
          else {
            await this.setNewPassword.show(after, true, true);
          }
        } else if (!isIresUser && UserModule.licences.length === 0) {
          if (doesClientHaveApp() && !this.activeUser?.licenceInfo?.licencesV3) {
            await this.selectedLicences.show(after);
          }
        }
      }, async () => {
        // #2610124: there, IRES Cloud's rules refuse a blocked or deleted user's session everything,
        // so the block arrives as this refusal rather than as the change above. Every other client
        // is left as it was.
        if (isOfficeAdminPortalClient()) {
          await this.signOutBlockedUser();
        }
      })
    );

    this.subscriptions.push(
      observeClient(async (client: Client) => {
        this.updateScaffoldContent();

        // #2610066: a blocked or deleted client is signed out with the reason. IRES users stay, as IRES
        // Cloud lets the IRES admin account in, and as the user check above exempts them.
        if (isClientSignInBlocked(client) && !iresSettingsAccess(this.activeUser)) {
          rememberSignInRefusal("CLIENT_BLOCKED");
          await this.signOut();
        } else if (mustChangePlaceholderCredentials(client)) {
          await this.changeEmailAndPassword.show();
        } else {
          // Run the stale open entry check once after the first client data load.
          this.checkAndHandleStaleOpenEntry();
        }
      })
    );

    this.subscriptions.push(
      observeRoleSettings((roleSettings: RoleSettings) => {
        RoleSettingsModule.setRoleSettings(roleSettings);

        // The nav has to be rebuilt here, as it already is for the client and the system
        // configuration. `scaffoldItems` is a plain array filled by `items()`, not a computed, so
        // nothing recomputes it when the store changes.
        //
        // Without this a **role-resolved** entry is missing after a hard refresh:
        // `RoleSettingsModule` starts on defaults that grant nothing, and this observer is what
        // replaces them, so every earlier build of the nav asked `rateDryingsAccess()` before the
        // answer existed and got `false`. It came back only if some later trigger happened to fire.
        // It also means a capability granted while the user is signed in now shows up immediately.
        this.updateScaffoldContent();
      })
    );

    this.subscriptions.push(
      observeReportSettings((reportSettings: ReportSettings) => {
        ReportSettingsModule.setReportSettings(reportSettings);
      })
    );

    this.subscriptions.push(
      observeUserSettings((userSettings: UserSettings) => {
        UserSettingsModule.setUserSettings(userSettings);
      })
    );

    this.subscriptions.push(
      observeBranchesOfGroup((branches: MemberClientBranch[]) => {
        BranchesModule.setBranchesOfGroup(branches);
      })
    );

    this.subscriptions.push(
      observeHyDryDeviceSettings((hyDryDeviceSettings: HyDryDeviceSettings) => {
        HyDryDeviceSettingsModule.setHyDryDeviceSettings(hyDryDeviceSettings);
      })
    );

    this.subscriptions.push(
      observeProjectManagementSettings((projectManagementSettings: ProjectManagementSettings) => {
        ProjectManagementSettingsModule.setProjectManagementSettings(projectManagementSettings);
      })
    );

    this.subscriptions.push(
      observeAllDevicesSettings((allDevicesSettings: AllDevicesSettings) => {
        AllDevicesSettingsModule.setAllDevicesSettings(allDevicesSettings);
      })
    );

    this.subscriptions.push(
      observeLocalDeviceCategoriesAndTemplates((deviceCategoriesAndTemplates: DeviceCategoriesAndTemplates) => {
        DeviceCategoriesAndTemplatesModule.setLocalDeviceCategoriesAndTemplates((deviceCategoriesAndTemplates))
      })
    );

    this.subscriptions.push(
      observeSharedDeviceCategoriesAndTemplates((deviceCategoriesAndTemplates: DeviceCategoriesAndTemplates) => {
        DeviceCategoriesAndTemplatesModule.setSharedDeviceCategoriesAndTemplates(deviceCategoriesAndTemplates)
      })
    );

    this.subscriptions.push(
      observeHyDryMessagesSettings((hyDryMessagesSettings: HyDryMessagesSettings) => {
        HyDryMessagesSettingsModule.setHyDryMessagesSettings(hyDryMessagesSettings)
      })
    );

    this.subscriptions.push(
      observeFinishedProjectsSettings((finishedProjectsSettings: FinishedProjectsSettings) => {
        FinishedProjectsSettingsModule.setFinishedProjectsSettings(finishedProjectsSettings)
      })
    );

    this.subscriptions.push(
      observeCompanySettings((companySettings: CompanySettings) => {
        CompanySettingsModule.setCompanySettings(companySettings);

        const user = getActiveUser();
        const userLanguage = user?.language;

        if (companySettings && !companySettings.areDefaultCompanySettings && !userLanguage) {
          changeLanguageTo(companySettings.language);
        }
      })
    );
    
    this.subscriptions.push(
      observeSystemConfiguration(
        (systemConfiguration: SystemConfiguration) => {
          SystemConfigurationModule.setSystemConfiguration(systemConfiguration);
          this.updateScaffoldContent();
        }
      )
    );
  }

  async beforeDestroy() {
    this.appUpdateChecker?.stop();
    this.appUpdateChecker = null;
    AppUpdateModule.clear();
    window.removeEventListener("resize", this.calculateVisibility);
    document.removeEventListener("visibilitychange", this.onPortalResumed);
    window.removeEventListener("focus", this.onPortalResumed);
    this.subscriptions.forEach((subscription) => subscription());
    this.toolbarActionsObserver?.disconnect();
    this.toolbarActionsObserver = null;

    if (this.toolbarActionsResolutionTimer != null) {
      clearTimeout(this.toolbarActionsResolutionTimer);
      this.toolbarActionsResolutionTimer = null;
    }
  }

  /** Signs a blocked user out with the reason, for the login screen (#2610066). */
  private async signOutBlockedUser() {
    rememberSignInRefusal("USER_BLOCKED");
    await this.signOut();
  }

  async signOut() {
    // Before the token write below, which the read-only guard refuses while "Sicht auf" is active.
    endViewAs();
    ClientModule.clear();
    localStorage.clear();

    const userId = this.activeUser?.id;
    if (userId) {
      try {
        await clearPortalSessionToken(userId);
      } catch (e) {
        // Non-blocking: proceed with sign-out even if clearing the token fails
      }
    }

    await auth().signOut();
  }

  /**
   * Checks for a stale (unclosed, previous-day) time tracking entry for the
   * authenticated user and handles it according to the client's feature policy:
   * - Time tracking enabled: shows a confirmation dialog with the proposed end
   *   time; the user may edit it before confirming.
   * - Time tracking disabled: silently applies the proposed close.
   *
   * Runs at most once per Scaffold lifecycle. All errors are caught silently so
   * that a missing or failing Cloud callable never blocks the portal startup.
   */
  async checkAndHandleStaleOpenEntry() {
    // The implicit close runs for ALL users. Scope and dialog are both governed by the
    // SERVER's time-tracking policy (returned in preview.policy), not Office's local
    // system-config read: Cloud derives which entries to consider from `timeTrackingEnabled`
    // (TT enabled → also non-project "other" entries; disabled → project/shared only). The
    // confirmation dialog is shown only when the policy requires confirmation (TT enabled)
    // AND the user may view time tracking (pre-release gate); otherwise the close is silent.
    //
    // Runs at most once per client-timezone day and never concurrently. Re-runnable
    // (not once-per-session) so a session left open across midnight still closes
    // yesterday's entry on resume — no fresh login required.
    if (this.staleCheckInFlight) return;
    // The close acts on the viewer's own entries, which "Sicht auf" may not change (ticket 2610051).
    // onViewAsSelectedChanged runs the check again once it ends.
    if (this.isViewAsSelected) return;
    const today = this.currentClientDay();
    if (this.lastStaleCheckDay === today) return;
    this.lastStaleCheckDay = today;
    this.staleCheckInFlight = true;

    try {
      // Server owns the scope: don't force `includeNonProjectEntries` — Cloud derives it
      // from the client's time-tracking policy (see the preview callable). Whether to show
      // the dialog is likewise governed by the server's authoritative policy, not Office's
      // local system-config read (which can diverge via admin-client inheritance).
      const preview = await previewOpenTimeTrackingAutoClose({
        clientNowMs: Date.now(),
      });

      // No open entry to close. If the overnight sweep already closed yesterday's entry and
      // left it flagged for review, offer the adjust dialog; otherwise nothing to do.
      if (!preview.hasStaleOpenEntry) {
        await this.handlePendingReview(preview);
        return;
      }
      if (
        !preview.staleMonthDocId ||
        !preview.staleDayKey ||
        !preview.entryId ||
        !preview.entryType ||
        preview.proposal?.proposedEndAtMs == null ||
        !preview.proposal?.proposalSource
      ) {
        return;
      }

      // Dialog only when the client's TT feature requires confirmation (TT enabled) AND
      // the user may view time tracking (pre-release gate). Otherwise close silently.
      const dialogMode =
        preview.policy?.requiresUserConfirmation === true &&
        this.canAlwaysViewTimeTracking;

      let userEditedEndAtMs: number | undefined;

      if (dialogMode) {
        const clientTimezone =
          CompanySettingsModule.companySettings?.timezone ?? DEFAULT_TIMEZONE;
        const result: StaleCloseDialogResult = await this.staleCloseDialog.show(
          preview,
          clientTimezone
        );
        if (!result.accepted) return;
        userEditedEndAtMs = result.userEditedEndAtMs;
      }

      await applyOpenTimeTrackingAutoClose({
        lockToken: preview.lockToken,
        staleMonthDocId: preview.staleMonthDocId,
        staleDayKey: preview.staleDayKey,
        entryType: preview.entryType,
        entryId: preview.entryId,
        proposedEndAtMs: preview.proposal.proposedEndAtMs,
        proposalSource: preview.proposal.proposalSource,
        userEditedEndAtMs,
        // User-confirmed close (dialog) → PORTAL ("O"); silent/implicit close → CLOUD_FUNCTION
        // ("C"), marking it as automatic rather than user-initiated.
        operationSource: dialogMode
          ? ProjectOperationSource.PORTAL
          : ProjectOperationSource.CLOUD_FUNCTION,
      });

      if (dialogMode) {
        SnackbarModule.showSuccess({ key: "staleEntryAutoClose.successMessage" });
      }
    } catch {
      // Non-blocking: stale-close check failures must not interrupt portal startup.
    } finally {
      this.staleCheckInFlight = false;
    }
  }

  /**
   * Offers the review dialog for an entry the overnight sweep already auto-closed and flagged
   * (`preview.pendingReview`). The dialog lets the user adjust the auto-guessed end; on confirm
   * the resolve is applied (writes `userSetEndOfWork` + re-attributes `endSource` to PORTAL only
   * if edited) and clears the flag. Gated to time-tracking-enabled clients, and — during the
   * pre-release rollout — to IRES users (same `canAlwaysViewTimeTracking` gate as the close
   * dialog). When the gate is not met the flag is simply left for a later login. All errors are
   * swallowed by the caller's try/catch, so this never blocks startup.
   */
  private async handlePendingReview(
    preview: PreviewOpenTimeTrackingAutoCloseResponse
  ): Promise<void> {
    const review = preview.pendingReview;
    if (
      !review ||
      !review.staleMonthDocId ||
      !review.staleDayKey ||
      !review.entryId ||
      !review.entryType
    ) {
      return;
    }

    // Only offer the dialog when the client's TT feature requires confirmation (TT enabled)
    // AND the user may view time tracking (pre-release gate). Otherwise leave the flag.
    const dialogMode =
      preview.policy?.requiresUserConfirmation === true && this.canAlwaysViewTimeTracking;
    if (!dialogMode) return;

    const clientTimezone =
      CompanySettingsModule.companySettings?.timezone ?? DEFAULT_TIMEZONE;

    // The dialog reads a preview-shaped object; map the pendingReview block onto it (the
    // persisted auto-close end becomes the proposed end the user can adjust).
    const dialogInput: PreviewOpenTimeTrackingAutoCloseResponse = {
      hasStaleOpenEntry: false,
      staleMonthDocId: review.staleMonthDocId,
      staleDayKey: review.staleDayKey,
      entryType: review.entryType,
      entryId: review.entryId,
      projectId: review.projectId,
      projectLogId: review.projectLogId,
      projectName: review.projectName,
      projectNumberOffice: review.projectNumberOffice,
      projectNumberIres: review.projectNumberIres,
      task: review.task,
      proposal: {
        proposedEndAtMs: review.proposedEndAtMs,
        entryStartAtMs: review.entryStartAtMs,
      },
      policy: preview.policy,
    };

    const result: StaleCloseDialogResult = await this.staleCloseDialog.show(
      dialogInput,
      clientTimezone
    );
    if (!result.accepted) return;

    await applyOpenTimeTrackingAutoClose({
      resolveReview: true,
      staleMonthDocId: review.staleMonthDocId,
      staleDayKey: review.staleDayKey,
      entryType: review.entryType,
      entryId: review.entryId,
      userEditedEndAtMs: result.userEditedEndAtMs,
      // The user reviewed it in Office → attribute the adjustment to PORTAL ("O"). The Cloud
      // only re-attributes endSource when the time was actually edited.
      operationSource: ProjectOperationSource.PORTAL,
    });

    if (result.userEditedEndAtMs !== undefined) {
      SnackbarModule.showSuccess({ key: "staleEntryAutoClose.successMessage" });
    }
  }

  /** Client-timezone day string (YYYY-MM-DD) used for the day-boundary guard. */
  private currentClientDay(): string {
    const tz = CompanySettingsModule.companySettings?.timezone ?? DEFAULT_TIMEZONE;
    try {
      return new Date().toLocaleDateString("en-CA", { timeZone: tz });
    } catch {
      return new Date().toLocaleDateString("en-CA");
    }
  }

  /** Re-check stale entries when the portal regains visibility/focus (e.g. resumed the next day). */
  private onPortalResumed = (): void => {
    if (document.visibilityState === "visible") {
      this.checkAndHandleStaleOpenEntry();
    }
  };

  async onSignOut() {
    const result = await this.confirmationDialog.show({
      title: this.$t("common.confirmSignOutTitle").toString(),
      message: this.$t("common.confirmSignOutMessage").toString(),
    });

    if (result) {
      await this.signOut();
    }
  }

  items() {
    if (isExternalSystem()) {
      return [
        {
          title: "pages.projects",
          icon: "mdi-inbox",
          action: "/main/projects",
        },
        {
          title: "pages.help",
          icon: "mdi-comment-question",
          action: "/main/help",
        },
      ];
    } else {
      return [
        {
          title: "pages.cockpit",
          icon: "mdi-content-paste",
          // The admin portal client has its own cockpit; the router would redirect there anyway, but
          // the entry has to carry the real path for the navigation highlight to match it.
          action: getCockpitPath(isOfficeAdminPortalClient()),
        },
        ...manageProjectsClientAccess(this.effectiveUser) && !this.hidesProjectFeatures
          ? [
              {
                title: "pages.projects",
                icon: "mdi-inbox",
                action: "/main/projects",
              },
            ]
          : [],
        ...(!this.hidesProjectFeatures
          ? [
              {
                title: "pages.devices",
                icon: "mdi-view-dashboard",
                action: "/main/devices",
              },
            ]
          : []),
        ...(manageAllDevicesClientAccess()
          ? [
              {
                title: "pages.allDevices",
                icon: "mdi-content-copy",
                action: "/main/allDevices",
              },
            ]
          : []
        ),
        ...(manageMessagesClientAccess() && !this.hidesProjectFeatures
            ? [
                {
                  title: "pages.messages",
                  icon: "mdi-message-alert",
                  action: "/main/messages",
                },
              ]
            : []
        ),
        ...(schedulingSettingsAccess(this.effectiveUser) &&
        this.projectManagement !== ProjectManagement.DEVICES_ONLY_WEBSITE &&
        !this.hidesProjectFeatures
          ? [
              {
                title: "pages.scheduling",
                icon: "mdi-calendar",
                action: "/main/scheduling",
              },
            ]
          : []),
        
        ...(vehicleManagementAccess(this.effectiveUser) &&
        this.projectManagement !== ProjectManagement.DEVICES_ONLY_WEBSITE &&
        !this.hidesProjectFeatures
          ? [
              {
                title: "pages.vehicles",
                icon: "mdi-van-utility",
                action: "/main/vehicles",
              },
            ]
          : []),
        ...(canAccessTimeTrackingHistory(
          manageTimeTrackingClientAccess(),
          alwaysAllowedToViewTimeTrackingAccess(this.effectiveUser)
        ) && !this.hidesProjectFeatures
          ? [
              {
                title: "pages.timeTrackingHistory",
                icon: "mdi-clock-outline",
                action: "/main/timeTrackingHistory",
              },
            ]
          : []),
        // Mira, below Zeiterfassung (Taimoor, 2026-10-02; was between Cockpit and Projekte).
        // IRES-only for now; `hasAccess` refuses the routes as well, so hiding the entry is not the
        // only gate.
        ...(miraAccess(this.effectiveUser) && !this.hidesProjectFeatures
          ? [
              {
                title: "pages.mira",
                icon: "mdi-chart-box-outline",
                action: "/main/mira",
              },
            ]
          : []),
        {
          title: "pages.settings",
          icon: "mdi-cog",
          action: "/main/settings",
        },
        {
          title: "pages.help",
          icon: "mdi-comment-question",
          action: "/main/help",
        },
        // The standalone Karte screen, gated on its own capability rather than on the address
        // features': it is still under development, and until 2026-09-07 the two shared one
        // capability, so releasing the finished address features would have brought this with them.
        // Hiding the entry is not enough on its own — `hasAccess` refuses the route as well.
        ...(mapPageAccess(this.effectiveUser) && !this.hidesProjectFeatures
          ? [
              {
                title: "pages.maps",
                icon: "mdi-map",
                action: "/main/maps",
              },
            ]
          : []
        ),
        // The portal landing page, back in the navigation now that more than one area has been
        // migrated out of the IRES Admin Android app. It was dropped while RENO review was the only
        // one, because a page holding a single tile was a click and a screen for nothing.
        //
        // Gated on portal membership ALONE, deliberately: the landing page is in
        // ADMIN_PORTAL_COMPONENTS but not in any capability list, and it hides the tiles a user
        // cannot reach. Requiring a capability here would take the entry away from a portal user who
        // holds a different one.
        // Not while "Sicht auf" is active: the IRES Admin Client is unavailable then (ticket 2610051).
        ...(this.isOfficeAdmin && !this.isViewAsSelected
          ? [
              {
                // `admin.title` and `mdi-shield-crown-outline`, the pair this entry had before it
                // was dropped, so the portal looks unchanged to the reviewers who already know it.
                title: "admin.title",
                icon: "mdi-shield-crown-outline",
                action: "/main/admin",
              },
            ]
          : []
        ),
        // RENO review keeps its own entry as well, straight to the filter screen: it is the area
        // reviewers live in, and making them go through the landing page every time would be a click
        // for nothing again.
        //
        // Gated on RATE_DRYINGS as well as on portal membership, because the target route is in
        // RATE_DRYINGS_COMPONENTS: without it a portal user who lacks the capability would be offered
        // an entry the router guard bounces them out of.
        ...(this.isOfficeAdmin && !this.isViewAsSelected && rateDryingsAccess(this.activeUser)
          ? [
              {
                title: "admin.renoReview.title",
                icon: "mdi-clipboard-check-outline",
                action: "/main/admin/renoReview",
              },
            ]
          : []
        ),
      ];
    }
  }

  calculateVisibility() {
    this.$nextTick(() => {
      const toolbar = this.$refs.toolbar as HTMLElement;

      if (toolbar) {
        localStorage.setItem("toolbarWidth", toolbar.offsetWidth.toString());
      }
    });
  }

  mounted() {
    this.startAppUpdateChecker();
    this.calculateVisibility();
    window.addEventListener("resize", this.calculateVisibility);
    document.addEventListener("visibilitychange", this.onPortalResumed);
    window.addEventListener("focus", this.onPortalResumed);
    this.$nextTick(() => {
      this.observeToolbarActions();
    });
  }
}
